var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pajamas:arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30125 6.60005C7.46685 6.42233 7.557 6.18728 7.55272 5.9444C7.54843 5.70152 7.45004 5.46979 7.27828 5.29802C7.10651 5.12626 6.87478 5.02787 6.6319 5.02358C6.38903 5.0193 6.15397 5.10945 5.97625 5.27505L1.9125 9.33755L1.25 10.0001L1.9125 10.6626L5.975 14.7251C6.15173 14.8959 6.3885 14.9905 6.63432 14.9885C6.88013 14.9865 7.11531 14.888 7.28921 14.7143C7.46312 14.5405 7.56182 14.3054 7.56407 14.0596C7.56633 13.8138 7.47194 13.5769 7.30125 13.4001L4.83875 10.9376H17.8125C18.0611 10.9376 18.2996 10.8388 18.4754 10.663C18.6512 10.4871 18.75 10.2487 18.75 10.0001C18.75 9.75141 18.6512 9.51295 18.4754 9.33714C18.2996 9.16132 18.0611 9.06255 17.8125 9.06255H4.83875L7.30125 6.60005Z",
    fill: "#5981E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.d6d75581c1d9efa74ad08ff363f9b86a.svg";
export { ForwardRef as ReactComponent };